import { Helmet } from "react-helmet-async";
import '../styles/o-pilates.min.css';
import FotoOsteoVitta1 from '../assets/FotoEstudio1.jpeg';
import FotoExercicio1 from '../assets/Exercicio1.png';
import FotoExercicio2 from '../assets/Exercicio2.png';
import FotoExercicio3 from '../assets/Exercicio3.png';
import FotoPilatesAdaptavel from '../assets/pilaes_adaptavel.jpg';


export default function Home() {

  return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/o-pilates" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma." />
        </Helmet>

        <main className='o-pilates'>
            <section className="pilates-whats-top">
                <div className="pilates-whats-top-title">
                    <h1>O que é <span>Pilates ?</span></h1>
                </div>

                <div className="pilates-whats-top-image">
                    <img src={FotoOsteoVitta1}/>
                </div>
            </section>

            <section className="pilates-whats-middle__01">

                <div className="pilates-whats-middle-text">
                    <h2>
                        Exercícios planejados para cuidar da sua saúde física e mental de forma integrada
                    </h2>

                    <span className="pilates-whats-text">
                        Pilates é uma prática corporal criada por Joseph Pilates que busca o equilíbrio entre força, 
                        flexibilidade e consciência corporal. O método é baseado em movimentos controlados, 
                        respiração e alinhamento postural, promovendo saúde e bem-estar de forma completa.
                    </span>
                </div>

                <div className="pilates-whats-middle-image">
                    <ul>
                        <li>
                            <img src={FotoExercicio1} width="280" height="300"/>
                        </li>
                        <li className="pilates-image-whats-middle_01">
                            <img src={FotoExercicio2} width="280" height="300"/>
                        </li>
                        <li>
                            <img src={FotoExercicio3} width="280" height="300"/>
                        </li>
                    </ul>
                </div>

                <div className="pilates-whats-middle-text">
                    <h2 className="pilates-whats-middle-text--title">
                        O Pilates conquistou grande popularidade como método de exercício no país
                    </h2>

                    <span className="pilates-whats-text">
                        Uma das maiores vantagens do método Pilates é sua versatilidade,  
                        ele atende muito bem a diferentes perfis:
                        Crianças, gestantes, idosos, pessoas em reabilitação ou simplesmente quem busca mais qualidade de vida no dia a dia
                    </span>
                </div>

            </section>


            <section className="pilates-whats-metodo">
                <h3>Pilates é um método Adaptável</h3>

                <p className="pilates-whats-text">
                    Os exercícios de Pilates são flexíveis e podem ser ajustados conforme suas necessidades, 
                    evitando a repetição monótona das mesmas séries.<br/> Essa capacidade de adaptação é fundamental para o sucesso do método com pessoas de diferentes perfis.
                </p>
            </section>

            <section className="pilates-whats-nucleo">

                <div className="pilates-whats-nucleo-container">
                    <h3>Núcleo Força</h3>
                    <p className="pilates-whats-text">
                        O fortalecimento do centro do corpo — conhecido como núcleo — é o alicerce do método Pilates. 
                        Esse núcleo é formado pelos músculos profundos do abdômen e das costas. 
                        Quando esses músculos estão fortes e ativados corretamente, eles trabalham em harmonia com os músculos mais superficiais do tronco, 
                        oferecendo suporte para a coluna e favorecendo a circulação.
                        <br/><br/>
                        Ao desenvolver a força do núcleo, você conquista maior estabilidade em toda a região central do corpo. 
                        Isso é essencial para aliviar tensões na coluna e é um dos principais motivos pelos quais o Pilates é tão 
                        eficaz no combate às dores nas costas. Com o tronco estabilizado, 
                        o corpo se movimenta com mais liberdade, eficiência e segurança.
                    </p>
                </div>

                <div className="pilates-whats-nucleo-img">
                    <img src={FotoPilatesAdaptavel}/>
                </div>

            </section>

            <section className="pilates-whats-principios">
                <h3>
                    Os seis princípios do Pilates: Centro, Movimento Fluido, Respiração, Precisão, Controle e Concentração
                </h3>

                <p className="pilates-whats-text">
                    Esses são os pilares que sustentam o método Pilates. Diferente de outras práticas, o Pilates valoriza 
                    mais a qualidade do movimento do que a quantidade de repetições. Cada exercício é executado com atenção total, 
                    foco na técnica e consciência corporal, o que garante resultados mais eficazes e duradouros em menos tempo.
                </p>
            </section>

            <section className="pilates-whats-matPilates">
                <h3>
                    Pilates no Solo (Mat Pilates) ou em Studio
                </h3>

                <p className="pilates-whats-text">
                    Os exercícios de Pilates podem ser praticados tanto no solo, com o peso do próprio corpo, quanto em estúdio, 
                    utilizando equipamentos criados por Joseph Pilates.
                    No Studio, os aparelhos contam com molas, polias e ajustes variados que permitem trabalhar 
                    com diferentes níveis de resistência e apoio. Isso proporciona uma prática mais personalizada, 
                    segura e adaptável às necessidades de cada aluno, desde iniciantes até os mais avançados.
                </p>
            </section>

        </main>
    </>
  );
}